export const END_URL = {
  CategoryList: "ContactUs/fetch-parent-categories",
  SubCategoryList: "ContactUs/fetch-categories",
  SubChildCategoryList: "ContactUs/fetch-sub-child-categories",
  ChannelPartners: "ContactUs/fetch-channel-partners",
  FetchDiySteps: "ContactUs/fetch-diy-steps",
  SubmitWatchoComplainAndFeedback: "ContactUs/SubmitWatchoComplainAndFeedback",
  WatchoComplain: "ContactUs/watcho-complain",
  UniFiedAPP: "https://unifiedbck.watcho.com/api/UniFiedAPP/GetUserDetail",
  Dishd2hunifiedbck:
    "https://dishd2hunifiedbck.watcho.com/api/UniFiedAPP/GetUserDetail",
  OTTSubscriber: "ContactUs/OTT-Subscribermaster",
  FaqList: "faq/entryall",
  AvailableCoupon: "ContactUs/available-coupon",
  ValidateCoupon: "ContactUs/validate-coupon",
  Authorize: "ContactUs/validation-token",
  UniFiedAPPS: "UniFiedAPP/GetUserDetail",
  GlobalConfig_URL: "Config/fetch-config",
};
